import React from 'react'

const ImageSkeleton = () => {
    return (
        <>
            {[...Array(12)].map((item) => (
                <div
                    key={item}
                    className="rounded-xl flex items-center justify-center p-2 border bg-gray-100 animate-pulse"
                >
                    <div className="w-[47px] h-[45px] bg-gray-200 rounded-lg"></div>
                </div>
            ))}
        </>
    )
}

export default ImageSkeleton